import { TokenName } from '@shared/constants';
import { formatNumberLocalized } from '@shared/helpers/formatters';
import { concatCurrencyToAmount } from '@shared/helpers/web3/formatters';

import { DialogProps } from '@radix-ui/react-dialog';
import { CustomDialog, DialogButton, DialogCancelButton } from '@ui/uikit/components/common/Dialog';
import { MarkCheck } from '@ui/uikit/components/icons/mono';

import { useLastRoundInfo } from '../../../model/web3Raffle/api/useLastRoundInfo';
import { useTicketPrice } from '../../../model/web3Raffle/api/useTicketPrice';

type Props = DialogProps & {
  ticketsAmount: number;
  tokenName: TokenName;
  linkToBlockExplorer: string;
  onClose: () => void;
};

export const SuccessPurchaseModal = ({
  ticketsAmount,
  tokenName,
  linkToBlockExplorer,
  onClose,
  ...props
}: Props) => {
  const { data: ticketPriceInUsdt } = useTicketPrice('USDT');
  const { data: ticketPriceInSqr } = useTicketPrice('SQR');
  const { data: roundInfo } = useLastRoundInfo();

  const totalInSqr = formatNumberLocalized(ticketsAmount * (ticketPriceInSqr?.value ?? 0));

  const totalInUsdt = formatNumberLocalized(ticketsAmount * (ticketPriceInUsdt?.value ?? 0));

  const total = tokenName === 'USDT' ? totalInUsdt : totalInSqr;

  const onOpenChangeHandler = (opened: boolean) => {
    if (!opened) {
      onClose();
    }
  };

  return (
    <CustomDialog {...props} onOpenChange={onOpenChangeHandler} size="sm">
      <div className="flex flex-col items-center text-center">
        <div className="pt-2 pb-4">
          <MarkCheck className="text-base-text-green w-12 h-12 max-md-msq:w-10 max-md-msq:h-10" />
        </div>
        <div className="text-h3-a text-base-text-primary mb-4 max-md-msq:mb-3 text-center">
          Tickets have been
          <br />
          successfully purchased
        </div>
        <div className="text-base-text-primary text-caption-sm-a mb-6 max-md-msq:mb-4">
          You have successfully purchased
          <br />
          <span className="text-caption-sm-strong-a">{ticketsAmount}</span> tickets for{' '}
          <span className="text-caption-sm-strong-a">
            {concatCurrencyToAmount(total, tokenName, {
              stableToDollar: false,
            })}
          </span>{' '}
          ({concatCurrencyToAmount(totalInUsdt, 'USDT')})
          <br />
          for{' '}
          <span className="text-caption-sm-strong-a">
            Raffle #{String(roundInfo?.roundId ?? '')}
          </span>
          .
        </div>
        <div className="w-full flex flex-col gap-2">
          <DialogButton variant="secondary" href={linkToBlockExplorer} target="_blank">
            Transaction
          </DialogButton>
          <DialogCancelButton variant="primary">Close</DialogCancelButton>
        </div>
      </div>
    </CustomDialog>
  );
};
